export { default } from './useScript';

export type * from './types';
